




























































































import { Component, Vue, Prop } from 'vue-property-decorator';

import { Surface, Picture, Typography } from '@/components/atoms';
import { FilledButton } from '@/components/molecules';
import TagSpecialCoin from '@/componentsV2/atoms/TagSpecialCoin/TagSpecialCoin.vue';
import ShareOffer from '@/components/ShareOffer/ShareOffer.vue';
import DiscountOffer from '@/components/molecules/DiscountOffer/DiscountOffer.vue';
import ShareArrow from '@/components/icons/ShareArrow.vue';
import ShareOfferTooltip from '@/components/ShareOfferTooltip/ShareOfferTooltip.vue';
import ImageSpecialCoinPreview from '@/components/organisms/Offers/ImageSpecialCoinPreview.vue';
import TagBirthday from '@/components/organisms/Offers/DataPresentation/TagBirthday.vue';
import OfferTypeTag from '@/components/molecules/OfferTypeTag/OfferTypeTag.vue';

import { EOfferStatusEnum } from '@/models/offer';

import { copyToClipboard } from '@/utils';
import DateUtils from '@/utils/DateUtils';
import isMobile from '@/utils/mobile-check';
import { isRemoteLoading } from '@/utils/remote-loading';

export const SpecialOfferTags = [
  {
    label: 'Storewide deal',
    type: 'storewide-deal',
    specialType: 'Storewide'
  },
  {
    label: 'Specific product / service',
    type: 'specific-product',
    specialType: 'ProductAndService'
  },
  { label: 'Birthday offer', type: 'birthday-offer', specialType: 'Birthday' }
];

@Component({
  components: {
    Surface,
    Picture,
    Typography,
    FilledButton,
    TagBirthday,
    TagSpecialCoin,
    ShareOffer,
    DiscountOffer,
    ImageSpecialCoinPreview,
    ShareArrow,
    ShareOfferTooltip,
    OfferTypeTag
  }
})
export default class ShareOfferComponent extends Vue {
  @Prop({ required: true }) offer!: any;
  activeTooltip = false;

  get isMobileDevice() {
    return isMobile();
  }

  get tPrefix() {
    return `offers.share`;
  }

  get remoteLoading() {
    return isRemoteLoading();
  }

  get tPrefixDetail() {
    return `offers.detail`;
  }

  get business() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  get businessName() {
    return this.business.name;
  }

  get description() {
    const { businessName } = this;
    const { title } = this.offer;
    return `${businessName} is offering ${title}. Get yours today on Twism.`;
  }

  get offerStatus() {
    if (this.offer.status === EOfferStatusEnum.INACTIVE)
      return EOfferStatusEnum.ACTIVE;
    return this.offer.status;
  }

  get createdOfferDate() {
    return `Created on ${DateUtils.formattedDate({
      date: new Date(),
      applyTimezone: true
    })}`;
  }

  async handleOpenClick(socialMedia: string) {
    if (socialMedia === 'more') {
      this.onShare();
    }
  }

  get statusDisclaimer() {
    const labelMapper: Record<string, string> = {
      expired_offline_delete_location: String(
        this.$t(
          `${
            this.tPrefixDetail
          }.statusDisclaimer.expired_offline_delete_location`
        )
      ),
      expired_offline_online_delete_location: String(
        this.$t(
          `${
            this.tPrefixDetail
          }.statusDisclaimer.expired_offline_online_delete_location`
        )
      ),
      active_online_delete_location: String(
        this.$t(
          `${this.tPrefixDetail}.statusDisclaimer.active_online_delete_location`
        )
      )
    };

    if (!labelMapper[this.offer.statusDisclaimer]) return '';

    return labelMapper[this.offer.statusDisclaimer];
  }

  async onShare() {
    const shareData = {
      title: this.offer.title,
      text: this.description,
      url: this.offer.branchLink
    };

    if ((navigator as any).share) {
      await (navigator as any).share(shareData);
    } else {
      this.activeTooltip = !this.activeTooltip;
    }
  }

  getTagItem(item: any) {
    return (
      SpecialOfferTags.filter(
        element => element.specialType === item.specialType
      )[0] || {}
    );
  }

  close() {
    this.$router.push('/special-coins-offers');
  }

  copyLink() {
    copyToClipboard(this.offer.branchLink, () =>
      this.$notification('Link copied to your clipboard', 'success')
    );
  }
}
